import { WalletAddressFormCta } from 'BreetComponents';
import { useUsdWithdrawRequestContext } from 'BreetHooks';
import { useCallback } from 'react';

const FormWalletAddressActions = ({ variant = 'default' }: { variant?: 'default' | 'save-address' }) => {
	const { formStage, formDataContextProps, resetWalletAddressProps } = useUsdWithdrawRequestContext();

	const onSavedWalletAddress = useCallback(() => {
		if (variant === 'save-address') {
			formStage.navigator.reset();
		}

		formStage.navigator.goTo(variant === 'default' ? 'crypto-transaction-details' : 'withdraw-funds')();
	}, [formStage.navigator, variant]);

	return (
		<WalletAddressFormCta
			formDataContextProps={formDataContextProps}
			onSavedWalletAddress={onSavedWalletAddress}
			onScanWalletAddress={formStage.navigator.goTo('scan-wallet-address')}
			resetWalletAddressProps={resetWalletAddressProps}
			variant={variant}
		/>
	);
};

export default FormWalletAddressActions;
